// Custom hook for managing search/filter input
import { useState } from "react";
import { useLocalization } from "../../providers/LocalizationProvider";

export function useFilter(initial = "") {
    // Filter value state
    const [value, set] = useState(initial);
    const { t } = useLocalization();
    
    // Pre-built input component with styling
    const input = (
      <input
        placeholder={t('common.filter')}
        value={value}
        onChange={(e)=>set(e.target.value)}
        className="px-3 py-2 rounded-xl border"
      />
    );
    return { value, set, input };
  }